import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router, { routerGuard } from './router'
import routerH5, { routerGuardH5 } from './router/router-h5'
import './assets/iconfont.js'

import 'ant-design-vue/es/message/style/css'
import 'ant-design-vue/es/modal/style/css'

import './styles/index.less'

import VueLazyload from 'vue-lazyload'
import 'highlight.js/styles/arduino-light.min.css'

// 配置项
const loadimage =
  'https://static5.yingsaidata.com/mip/img/8626817-yingsaidongjian-logo.png?x-image-process=image/resize,p_60'

const app = createApp(App)
// const errorimage = require('assets/img/common/error.gif')
app.use(VueLazyload, {
  preLoad: 1.3, //预加载的宽高比
  loading: loadimage //图片加载状态下显示的图片
})

app.use(createPinia())

// if (window.innerWidth > 768) {
//   routerGuard()
//   document.body.classList.add('pc')

//   app.use(router)
// } else {
//   routerGuardH5()
//   document.body.classList.add('h5')
//   app.use(routerH5)
// }
routerGuard()
document.body.classList.add('pc')

app.use(router)

app.mount('#app')
